<!-- 문의 답변달기 -->
<template>
  <div>
    <user-param-form page="grade" :grade_id="$route.query.id" @closeModal="closeModal"></user-param-form>
    <!--<div class="columns is-multiline">
      <div class="column is-full">
        <div class="btn-group-justify-end">
          <button class="button is-primary"
                  @click="saveData('add')" v-if="value.content_form">추가하기</button>
          <button class="button is-primary"
                  @click="saveData('modi')" v-else>수정하기</button>
        </div>
      </div>
      &lt;!&ndash; 회원 폼 종류 선택 &ndash;&gt;
      &lt;!&ndash;<div class="column is-full">
        <div class="box">
          <admin-box-item title="회원 폼 종류 선택">
            <div class="flex" style="flex-wrap: wrap">
              <div class="lp-form-type"
                   :class="{'selected':selectedItem.form_id===type.value}"
                   v-for="(type, idx) in value.types" :key="idx"
                   @click="clickFormType(type, idx)">
                <input class="input lp-form-type-input"
                       :value="type.label"
                       @input="e => inputLabel(e, type)"
                       type="text"
                       maxlength="15">
                <i class="material-icons lp-form-close"
                   @click="deleteForm"
                   v-if="selectedItem.form_id===type.value && value.types.length > 0">close</i>
              </div>
              <div class="lp-form-add" @click="addForm">+</div>
            </div>
          </admin-box-item>
        </div>
      </div>&ndash;&gt;
      <div class="column is-full">
        <div class="box">
          <admin-box-item title="회원 폼 종류">
            <div class="flex">
              <div class="lp-form-type" v-for="(type, idx) in value.types">

              </div>
            </div>
          </admin-box-item>
        </div>
      </div>

      &lt;!&ndash; 회원 기본 정보 &ndash;&gt;
      <div class="column is-full">
        <div class="box">
          <admin-box-item title="회원 기본 정보: ">
            <div slot="header-right-spot">
              <div class="lp-group-justfy-end"
                   style="margin:0;position:absolute;top:-4px;left:140px;font-size:21px;font-weight:300;">
                <span v-text="selectedItem.name"></span>
              </div>
            </div>
            <div style="overflow-x: auto">
              <div style="width: 1080px">
                <div class="flex" style="border-bottom: 2px solid #dbdbdb; text-align: center">
                  <div style="width:24px"></div>
                  <div class="lp-param-td lp-param-head" style="width: 20%">필드명 및 포맷 비주얼</div>
                  <div class="lp-param-td lp-param-head" style="width: 15%">타입</div>
                  <div class="lp-param-td lp-param-head" style="width: 10%">활성화 여부</div>
                  <div class="lp-param-td lp-param-head" style="width: 10%">필수입력 여부</div>
                  <div class="lp-param-td lp-param-head" style="width: 15%">label</div>
                  <div class="lp-param-td lp-param-head" style="width: 15%">description</div>
                  <div class="lp-param-td lp-param-head" style="width: 15%">placeholder</div>
                </div>

                <draggable v-model="value.data">
                  <div
                    v-for="(info, idx) in value.data" :key="idx"
                    v-if="!info.is_param" class="flex">
                    <div style="color: #bababa">
                      <i class="material-icons lp-drag-indicator"
                         style="line-height:2.5rem;padding:0">drag_indicator</i>
                    </div>
                    <div class="lp-param-td" style="width: 20%">{{ info.name }}</div>
                    <div class="lp-param-td" style="width: 15%"><span v-if="info.format">{{ convertFormat(info.format) }}</span></div>
                    <div class="lp-param-td" style="width: 10%">
                      <toggle-button @change="e=>changeEnable(e, idx)"
                                     :value="info.enable"
                                     :sync="true"
                                     class="changed-font"
                                     :width="70"
                                     :height="24"
                                     :labels="{'checked':'활성화', 'unchecked':'비활성화'}"></toggle-button>
                    </div>
                    <div class="lp-param-td" style="width: 10%">
                      <toggle-button @change="e => selectValidate(e, idx)"
                                     :value="info.validate.valid_required"
                                     :sync="true"
                                     class="changed-font"
                                     :width="70"
                                     :height="24"
                                     :labels="{'checked':'사용', 'unchecked':'미사용'}"></toggle-button>
                    </div>
                    <div class="lp-param-td" style="width: 15%"><input class="input"
                                                                       :value="info.label"
                                                                       @input="e => info.label = e.target.value"
                                                                       type="text" maxlength="20"></div>
                    <div class="lp-param-td" style="width: 15%"><input class="input"
                                                                       :value="info.description"
                                                                       @input="e => info.description = e.target.value"
                                                                       type="text" maxlength="30"></div>
                    <div class="lp-param-td" style="width: 15%"><input class="input"
                                                                       :value="info.placeholder"
                                                                       @input="e => info.placeholder = e.target.value"
                                                                       type="text" maxlength="30"></div>
                  </div>
                </draggable>
              </div>
            </div>
          </admin-box-item>
        </div>
      </div>
      &lt;!&ndash; 추가된 맞춤 DB &ndash;&gt;
      <div class="column is-full">
        <div class="box">
          <admin-box-item title="추가된 맞춤 DB">
            <div style="overflow-x: auto">
              <div style="width:1080px">
                <div class="flex" style="border-bottom: 2px solid #dbdbdb; text-align: center">
                  <div style="width:24px"></div>
                  <div class="lp-param-td lp-param-head" style="width: 20%">필드명 및 포맷 비주얼</div>
                  <div class="lp-param-td lp-param-head" style="width: 15%">타입</div>
                  <div class="lp-param-td lp-param-head" style="width: 10%">활성화 여부</div>
                  <div class="lp-param-td lp-param-head" style="width: 10%">필수입력 여부</div>
                  <div class="lp-param-td lp-param-head" style="width: 15%">label</div>
                  <div class="lp-param-td lp-param-head" style="width: 15%">description</div>
                  <div class="lp-param-td lp-param-head" style="width: 15%">placeholder</div>
                </div>

                <draggable v-model="value.data">
                  <div
                    v-if="param.is_param"
                    v-for="(param, idx) in value.data" :key="idx"
                    class="flex">
                    <div style="color: #bababa">
                      <i class="material-icons lp-drag-indicator" style="line-height:2.5rem;padding:0">
                        drag_indicator
                      </i>
                    </div>
                    <div class="lp-param-td" style="width: 20%">{{ param.name }}</div>
                    <div class="lp-param-td" style="width: 15%"><span v-if="param.format">{{ convertFormat(param.format) }}</span></div>
                    <div class="lp-param-td" style="width: 10%">
                      <toggle-button @change="e=>changeEnable(e, idx)"
                                     :value="param.enable"
                                     :sync="true"
                                     class="changed-font"
                                     :width="70"
                                     :height="24"
                                     :labels="{'checked':'사용', 'unchecked':'미사용'}"></toggle-button>
                    </div>
                    <div class="lp-param-td" style="width: 10%">
                      <toggle-button @change="e => selectValidate(e, idx)"
                                     :value="param.validate.valid_required"
                                     :sync="true"
                                     class="changed-font"
                                     :width="70"
                                     :height="24"
                                     :labels="{'checked':'사용', 'unchecked':'미사용'}"></toggle-button>
                    </div>
                    <div class="lp-param-td" style="width: 15%">
                      <input class="input"
                             :value="param.label"
                             @input="e => param.label = e.target.value"
                             type="text"
                             maxlength="20">
                    </div>
                    <div class="lp-param-td" style="width: 15%">
                      <input class="input"
                             :value="param.description"
                             @input="e => param.description = e.target.value"
                             type="text"
                             maxlength="30">
                    </div>
                    <div class="lp-param-td" style="width: 15%">
                      <input class="input"
                             :value="param.placeholder"
                             @input="e => param.placeholder = e.target.value"
                             type="text"
                             maxlength="30">
                    </div>
                  </div>
                </draggable>
              </div>
            </div>
          </admin-box-item>
        </div>
      </div>
    </div>-->
  </div>
</template>

<script>

  import AdminFormItem from "../admin/AdminFormItem";
  import LpAdmDropInput from "../common/LpAdmDropInput";
  import draggable from 'vuedraggable'
  import UserParamForm from "../../page/user/UserParamForm";

  export default {
    props: ['content_form'],
    components: {
      UserParamForm,
      LpAdmDropInput,
      AdminFormItem,
      draggable
    },
    data() {
      return {
        // 등급관리(UserGrade의 id값)
        value: {
          data: [],
          id: 0,
        },
        // 맞춤 db list
        param_list: [],
        selectedItem: {
          form_id: 0,
          name: ''
        },
      }
    },
    computed: {
    },
    created() {
      this.getDetail();
    },
    watch: {
    },
    methods: {
      changeEnable(e, idx) {
        this.value.data[idx].enable = e.value;
      },
      // 활성화 여부
      selectValidate(e, idx) {
        this.value.data[idx].validate.valid_required = e.value;
        this.value.data[idx].validate.required = e.value;
      },
      paramAllList() {
        // 파라미터 리스트
        this.$axios.get(this.getUrl('member/user/param')).then(res => {
          this.param_list = res.data;
          this.checkParam(this.param_list);
        })
      },
      checkParam(param) {
        if ( param === undefined || param.length === 0 ) {
          return;
        }
        let id_list = this.value.data.map(item => {
          return item.id;
        })
        param.forEach(item1 => {
          /* value_
          * param_id
          * param_type
          * choice_items */
          if (!id_list.includes(item1.id)) {
            if (item1.param_type >= 0 && item1.param_type <= 8) {
              this.value.data.push(item1)
            }
          }
        })
      },

      // 폼 상세 가져오기
      getDetail(){
        if(this.content_form) {
          this.$axios.get('admin/member/formdata/' + this.content_form.id).then(res => {
            if (res.status === 200) {
              this.value.data = res.data.data;
              this.paramAllList();
            }
          })
        }
        else {
          this.$axios.get('public/member/content').then(res => {
            if (res.status === 200) {
              this.value.data = res.data;
              this.paramAllList();
            }
          })
        }
      },
      cancelModal(){
        this.$store.commit('cancelModal');
      },
      closeModal(){
        this.$store.commit('closeModal');
      }
    }
  }
</script>
<style lang="stylus" type="stylus" scoped>
  @import '~assets/css/lp_main'
  .tr-whole-borde th
    padding 12px 6px
    text-align center

  .many-field-tr td
    padding 6px

  .td-btn
    cursor pointer

  .td-btn:hover
    background-color #caf6ec
    font-weight bold
    font-size 1rem
    color $primary

  .prod-list-page-selected
    color #18a4ed

  .prod-list-page-not-selected
    color #666

  .primary
    color $primary

  .prod-tag
    background-color #ebab39
    display inline-block
    padding 4px 10px
    color #fff
    border-radius 3px
    margin 2px

  .prod-search-bgcolor
    background-color #f1f7f8

  .lp-form-type
    border 1px solid #7a7a7a
    border-radius 3px
    cursor pointer
    margin-right 8px
    margin-bottom 2px
    position relative

  .lp-form-close
    position absolute
    right 2px
    top 5px
    font-size 1.5rem

  .selected
    color $primary
    border 1px solid $primary
    background-color unset

  .lp-form-add
    width 60px
    border 1px solid
    border-radius 3px
    text-align center
    margin-right 8px
    cursor pointer
    height 34px
    padding-top 5px

  .lp-form-add:hover
    background-color $primary
    color white

  .lp-form-type-input
    border 0
    box-shadow unset
    padding-right 24px

  .lp-param-td
    padding 0.5em 0.75em
    text-align center

  .lp-param-head
    color #363636
    font-weight bold
</style>
